

import $api from '../api/api';
import $config from '../config/config'
import wxuserUtil from './wxuserUtil'

/**
 *   企业微信配置信息
 *   @deprecated 此文件废弃
 */
class Wxchart {
  constructor(options) {
    this.config = {
      corpId: "",
      redirectUri: $config.serverURL,
      agentId: "",
      scope: 'snsapi_privateinfo ',
      response_type: "code"
    }
    this.wxSign = {};

    this.$getCode = this.getCode;
    this.getCode();
  }
  getCode() {
    wxuserUtil.clearCache();
    wxuserUtil.removeCode(wxuserUtil.KEY_CODE);
    wxuserUtil.localStorage.remove('wxPZ');

    var r = $api.getDeploys();
    if (r.success == true) {
      wxuserUtil.localStorage.set("wxPZ",r.data);
      if (window.location.search.indexOf('code') < 0) {
        let authPageBaseUri = 'https://open.weixin.qq.com/connect/oauth2/authorize'
        let authParams = `?appid=${r.data.corpId}&response_type=code&scope=${this.config.scope}&agentid=${r.data.agentId}#wechat_redirect` + '&redirect_uri=' + encodeURIComponent(location.href)
        let url = authPageBaseUri + authParams;
        window.location.href = url
      }
      if (window.location.href.indexOf('code') != -1) {
        let code_ = window.location.href.split("?")[1].split("&")[0].split("=")[1];
        wxuserUtil.setCode(code_);
      }
    }

  }
  split_url(URL) {
    var url = URL;
    var Request = new Object();
    try {
      if (url.indexOf("?") != -1) {
        var obj = url.split("?")[1], list = [];
        if (obj.indexOf("&") != -1) {
          var _List_ = obj.split("&");
          for (var i = 0; i < _List_.length; i++) {
            if (_List_[i]) {
              var _split_ = _List_[i].split("=")
              Request[_split_[0]] = _split_[1];
            }
          }
        } else {
          if (obj) {
            var _split_ = obj.split("=")
            Request[_split_[0]] = _split_[1];
          }
        }
        return Request;
      } else {
        return {};
      }
    } catch (e) { }
  }


  WxchartApi() {
    wx.config({
      debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: this.wxSign.appId, // 必填，公众号的唯一标识
      timestamp: this.wxSign.timestamp, // 必填，生成签名的时间戳
      nonceStr: this.wxSign.nonceStr, // 必填，生成签名的随机串
      signature: this.wxSign.signature,// 必填，签名
      jsApiList: [
        "onMenuShareTimeline",
        'checkJsApi',
        'openEnterpriseChat',
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'onMenuShareQZone',
        'hideMenuItems',
        'showMenuItems',
        'hideAllNonBaseMenuItem',
        'showAllNonBaseMenuItem',
        'translateVoice',
        'startRecord',
        'stopRecord',
        'onVoiceRecordEnd',
        'playVoice',
        'onVoicePlayEnd',
        'pauseVoice',
        'stopVoice',
        'uploadVoice',
        'downloadVoice',
        'chooseImage',
        'previewImage',
        'uploadImage',
        'downloadImage',
        'getNetworkType',
        'openLocation',
        'getLocation',
        'hideOptionMenu',
        'showOptionMenu',
        'closeWindow',
        'scanQRCode',
        'chooseWXPay',
        'openProductSpecificView',
        'addCard',
        'chooseCard',
        'openCard',
        'openAddress'
      ] // 必填，需要使用的JS接口列表
    });
    wx.ready(function () {   //需在用户可能点击分享按钮前就先调用

    });
  }
}


export default Wxchart;



// WEBPACK FOOTER //
// ./src/common/wxChart.js